export default {
  methods: {
    setCustomTitle(title) {
      const routeName = this.$route.name;
      this.$store.dispatch('setPageTitle', { routeName, title });
      document.title = title;
    },
    resetTitle() {
      const routeName = this.$route.name;
      const defaultTitle = this.$route.meta.title || 'JLDA';
      this.$store.dispatch('setPageTitle', { routeName, title: '' });
      document.title = defaultTitle;
    }
  }
};
